import { render, staticRenderFns } from "./SportOrganizationTicketPersonalization.vue?vue&type=template&id=faf57010&scoped=true"
import script from "./SportOrganizationTicketPersonalization.vue?vue&type=script&lang=js"
export * from "./SportOrganizationTicketPersonalization.vue?vue&type=script&lang=js"
import style0 from "./SportOrganizationTicketPersonalization.vue?vue&type=style&index=0&id=faf57010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf57010",
  null
  
)

export default component.exports